import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RouteUtil} from '../../util/route.util';
import {SignInComponent} from './sign-in/sign-in.component';

const routes: Routes = [{
  path: RouteUtil.SIGN_IN_COMPONENT,
  component: SignInComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CommonModuleRoutingModule {
}
